import { lowerCase } from "lodash";
import { useMemo } from "react";
import { RequestState } from "../../../../../constants/request-state";
import { SubscriptionFeature } from "../../../../../types/billing/SubscriptionFeature";
import { isRequesting } from "../../../../../utils";
import { ChartRequiredFeature } from "../../../../access/ChartRequiredFeature";
import { DashboardSkeleton } from "../../../../dashboard/DashboardSkeleton";
import { DashboardWidget, DashboardWidgetContent, DashboardWidgetHeader } from "../../../../dashboard/widget";
import { IssuanceSpreadBase } from "../../../../../types/dashboard/IssuanceSpread";
import { IssuanceSpreadChart } from "../../../../dashboard/usBslNewIssueSpreads/IssuanceSpreadChart";

export type TField = keyof Pick<IssuanceSpreadBase, 'was' | 'warf' | 'ds' | 'wal'>;

interface Props {
    title: string
    description: string
    requestState: RequestState
    comparableSpread: IssuanceSpreadBase
    dealSpread: IssuanceSpreadBase
    field: TField;
    divId: string
    chartNameLimitedPlan?: string
}

export function ComparativeMetricsWidget({ title, description, requestState, comparableSpread, dealSpread, field, divId, chartNameLimitedPlan }: Props) {
    const getDimension = (spread: IssuanceSpreadBase) =>
        spread === comparableSpread ? "Comparable Deals" : "This Deal"

    const chart = useMemo(() =>
        <IssuanceSpreadChart
            spreads={[comparableSpread, dealSpread]}
            fieldSelector={spread => spread[field]}
            divId={divId}
            getDimension={getDimension}
        />,
        // eslint-disable-next-line
        [comparableSpread, dealSpread, divId, field]);

    return (
        <DashboardWidget title={title} className="new-issue-chart-box">
            <DashboardSkeleton inProgress={isRequesting(requestState)}>
                <ChartRequiredFeature
                    feature={SubscriptionFeature.IssuanceMonitorFullAccess}
                    chartName={title}
                    chartNameLimitedPlan={chartNameLimitedPlan}
                    blockedClassName={"restricted-placeholder-" + lowerCase(title).replace(/\s+/g, "-")}
                >
                    <DashboardWidgetHeader>
                        <h3>{title}</h3>
                    </DashboardWidgetHeader>
                    <DashboardWidgetContent
                        requestState={requestState}
                        description={description}
                    >
                        {chart}
                    </DashboardWidgetContent>
                </ChartRequiredFeature>
            </DashboardSkeleton>
        </DashboardWidget>
    );
}